module.exports = {
    development: {
      //apiHost: 'http://172.28.107.112:8777/pgdp-icg',
      sitekey: '6Lday5sUAAAAAPKKjCE9UjUftrXHyB4QdvXTsqLe', //6Lfv754UAAAAAAo9SYvCC3tXXRF53mp8AwlPG27C
      apiHost: '/api/pgdp-icg',
      icgHost: 'https://dev.private.omgut.com',
    },
    // // 预览环境
    // production: {
    //   sitekey: '6Lfv754UAAAAAAo9SYvCC3tXXRF53mp8AwlPG27C',
    //   apiHost: '/pgdp-icg',
    //   icgHost: 'https://dev.private.omgut.com'
    // }
    //生产环境
    production: {    
      sitekey: '6Lday5sUAAAAAPKKjCE9UjUftrXHyB4QdvXTsqLe',
      apiHost: '/pgdp-icg',
      icgHost: 'https://api.private.omgut.com',
    }
  };
  


// WEBPACK FOOTER //
// ./src/config/index.js